export class MainHeaderlabel_HN {

    mainHeader: {
        title: string;
        welcomeText: string;
        customerCare : string;
    }

    menu: {
        home: string;
        about: string;
        howItWorks: string;
        logout: string;
        faq: string;
    }

    about: {
        title: string;
        closeBtn: string;
        hindi: string;
        english: string;
    }

    constructor() {

        this.mainHeader = {
            title: "स्मार्ट फाइनेंस प्लेटफॉर्म",
            welcomeText: "स्वागत हे",
            customerCare :" 1-800-209-3456"

        }

        this.menu = {
            home: "घर",
            about: "तकरीबन",
            howItWorks: "यह काम किस प्रकार करता है",
            logout: "लॉग आउट",
            faq: "सामान्य प्रश्न"
        }

        this.about = {
            title: "तकरीबन",
            closeBtn: "बंद करे",
            hindi: "हिंदी",
            english: "ENGLISH"
        }
    }
}